/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      function generateBreadcrumbs() {
        let breadcrumbs = '';
        const filterArray = $( '.filters-form' ).serialize().split( '&' );

        if ( $( '.filters-form' ).serialize().length > 0 ) {
          $( filterArray ).each( function( index, filter ) {
            const key = filter.split( '=' )[0];
            const val = filter.split( '=' )[1];
            const label = $( 'input[name="' + key + '"][value="' + val + '"]' ).next().text();
            breadcrumbs = breadcrumbs + ', ' + label;
          } );
        }

        breadcrumbs = breadcrumbs.slice( 2 );

        if ( breadcrumbs.length > 0 ) {
          if ( !$( '.breadcrumbs-list .breadcrumbs' ).length ) {
            $( '.breadcrumbs-list' ).append( '<li class="mr-3 last:mr-0 breadcrumbs">' + breadcrumbs + '</li>' );
          } else {
            $( '.breadcrumbs-list .breadcrumbs' ).text( breadcrumbs );
          }
        } else {
          if ( $( '.breadcrumbs-list .breadcrumbs' ).length ) {
            $( '.breadcrumbs-list .breadcrumbs' ).remove();
          }
        }

        return breadcrumbs;
      }

      generateBreadcrumbs();

      // Run the ajax function to filter the products, and replace the current grid with the filtered grid
      function filterProducts( page = 1 ) {
        $( '.products-area' ).addClass( 'is-loading' );
        let doingAjax = false;
        const data = {
          'filters': $( '.filters-form' ).serialize(),
          'page': page,
        };

        const paramData = {
          // 'page': page,
        };

        let searchString = '?';
        const filterArray = $( '.filters-form' ).serialize().split( '&' );
        let prevKey = '';

        if ( $( '.filters-form' ).serialize().length > 0 ) {
          $( filterArray ).each( function( index, filter ) {
            const key = filter.split( '=' )[0];
            const val = filter.split( '=' )[1];

            if ( key == prevKey ) {
              searchString = searchString + ',' + val;
            } else {
              if ( index > 0 ) {
                searchString += '&';
              }

              searchString = searchString + filter;
            }

            prevKey = key;
          } );

          searchString += '&' + $.param( paramData );
        } else {
          searchString += $.param( paramData );
        }

        const newUrl = document.location.protocol + '//' + document.location.hostname + document.location.pathname + searchString;
        window.history.pushState( 'Filtered Products', 'Title', newUrl );

        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'products/filter',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.products-area' ).html( data.new_products );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
            $( '.products-area' ).removeClass( 'is-loading' );
            generateBreadcrumbs();
          },
        } );
      }

      function checkCurrentFilters() {
        if ( $( '.filters-form .filter input[type="checkbox"]:checked' ).length > 0 ) {
          $( '.current-filters' ).show();
        } else {
          $( '.current-filters' ).hide();
        }
      }

      // Filter the products
      $( document ).on( 'change', '.filter input', function() {
        filterProducts();
        $( '.current-filters__filters' ).html( '' );
        $( '.current-filters' ).show();
        $( '.filters-form .filter input[type="checkbox"]:checked' ).each( function( key, checkbox ) {
          $( '.current-filters__filters' ).append( '<span data-for="' + $( checkbox ).val() + '">' + $( checkbox ).next().text() + '<button class="remove" title="Remove" aria-label="Remove"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></button></span>' );
        } );
        checkCurrentFilters();
      } );

      // Load current filters on page load
      $( '.filters-form .filter input[type="checkbox"]:checked' ).each( function( key, checkbox ) {
        $( '.current-filters__filters' ).append( '<span data-for="' + $( checkbox ).val() + '">' + $( checkbox ).next().text() + '<button class="remove" title="Remove" aria-label="Remove"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></button></span>' );
      } );

      // Remove a filter
      $( document ).on( 'click', '.current-filters__filters .remove', function() {
        $( '.filters-form input[type="checkbox"][value="' + $( this ).closest( 'span' ).attr( 'data-for' ) + '"]' ).prop( 'checked', false );
        $( this ).closest( 'span' ).remove();
        checkCurrentFilters();

        filterProducts();
      } );

      // Change the current page
      $( document ).on( 'click', '.pagination button', function( e ) {
        e.preventDefault();
        filterProducts( $( this ).attr( 'data-page' ) );
      } );

      // Remove all filters
      $( '.clear-filters' ).on( 'click', function() {
        $( '.current-filters__filters' ).html( '' );
        checkCurrentFilters();
        $( '.filter input[type="checkbox"]' ).prop( 'checked', false );
        $( '.filter input[type="number"]' ).each( function() {
          $( this ).val( $( this ).attr( 'value' ) );
        } );

        filterProducts();
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'shop', COMPONENT );
} )( app );
